import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { CutLinesComponent } from '../cut-lines.component';
import { CutLineMode } from '../../../../../models/enum/shared/cut-line-mode.enum';
import type { CardData } from '../../../../../models/print-cards/card-data';
import { GRID_COLUMN_GAP_WITH_NO_BLEED_ON_REGULAR_PAPER } from '../../../models/grid-column-gap';
import { ShelfTalkerCardData } from '../../../../../models/shelf-talkers/shelf-talker-card-data';

@Component({
  selector: 'app-print-card-left-cut-lines',
  templateUrl: './print-card-left-cut-lines.component.html',
  styleUrls: ['./print-card-left-cut-lines.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PrintCardLeftCutLinesComponent extends CutLinesComponent {
  @Input() cardsAsData: CardData[] | ShelfTalkerCardData[];

  // eslint-disable-next-line no-restricted-syntax
  @HostBinding('style.justify-content') get alignItems() {
    switch (this.layoutInstructions?.cutLineMode) {
      case CutLineMode.HugPerimeter:
        return 'flex-start';
      case CutLineMode.HugContent:
        return 'flex-end';
      case CutLineMode.Extended:
        return 'stretch';
    }
    return null;
  }

  protected readonly GRID_COLUMN_GAP_WITH_NO_BLEED_ON_REGULAR_PAPER = GRID_COLUMN_GAP_WITH_NO_BLEED_ON_REGULAR_PAPER;
}
